// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1Tcls","unreadBadge":"styles_unreadBadge__1hKsQ","modalContent":"styles_modalContent__3QVWu","modal":"styles_modal__3oWmw"};